import {getMenuItemNameForAnalytics} from '@rdcomponents/navigation/navigation-helper';
import {nameForAnalytics} from '@rdcomponents/navigation/navigation-type';

import {appRoute} from '../../../../app-route';
import {ReviewsGeneratorActivation} from '../../../../page/main/reviews-generator/pages/reviews-generator-activation';
import {ReviewsGeneratorIndex} from '../../../../page/main/reviews-generator/reviews-generator-index';
import {useLicenses} from '../../../../provider/license/license-hook';
import {useLocale} from '../../../../provider/locale/locale-hook';
import {useUser} from '../../../../provider/user/user-hook';
import {useReviewGeneratorMailingLicensesList} from '../../../../service/reviews-generator/review-generator-mailing';
import {FeaturesEnum} from '../../../../service/user/user-type';
import {NavigationItemConfigType} from '../routing-type';

import {ReactComponent as MobileStar} from './images/mobile-star.svg';

export function useReviewsGeneratorNavigation(): Array<NavigationItemConfigType> {
    const {user} = useUser();
    const {licenses, availableFeatures, enabledFeatures} = useLicenses();
    const {getLocalizedString} = useLocale();
    const {data: ReviewGeneratorMailingLicenses} = useReviewGeneratorMailingLicensesList();

    const reviewsGeneratorLicenses = licenses[FeaturesEnum.reviewsGenerator]?.isActive;
    const mailingListLicence =
        licenses[FeaturesEnum.mailingListLicence]?.isActive || ReviewGeneratorMailingLicenses?.length !== 0;

    const isMailingsAvailable = availableFeatures[FeaturesEnum.mailingListLicence] && !user?.isDoubleGisUser;

    return [
        {
            isAvailable:
                availableFeatures[FeaturesEnum.reviewsGenerator] &&
                enabledFeatures.includes(FeaturesEnum.reviewsGenerator),
            path: appRoute.reviewsGenerator.path,
            icon: <MobileStar />,
            label: getLocalizedString('CATEGORY_NAME__REVIEWS_GENERATOR'),
            [nameForAnalytics]: getMenuItemNameForAnalytics('CATEGORY_NAME__REVIEWS_GENERATOR'),
            exact: false,
            redirectPath: appRoute.reviewsGeneratorMailings.path,
            deniedPath: [appRoute.reviewsGenerator.path],
            component:
                reviewsGeneratorLicenses || mailingListLicence ? ReviewsGeneratorIndex : ReviewsGeneratorActivation,
            // todo: остальные роуты находятся в родительском компоненте ReviewsGeneratorIndex
            // todo: think about replace components to here
            children: [
                {
                    isAvailable: isMailingsAvailable,
                    isActivated: isMailingsAvailable && mailingListLicence,
                    path: appRoute.reviewsGeneratorMailings.path,
                    label: getLocalizedString('CATEGORY_NAME__REVIEWS_GENERATOR__MAILINGS'),
                    [nameForAnalytics]: getMenuItemNameForAnalytics('CATEGORY_NAME__REVIEWS_GENERATOR__MAILINGS'),
                },
                {
                    isAvailable: isMailingsAvailable,
                    isActivated: isMailingsAvailable && mailingListLicence,
                    path: appRoute.reviewsGeneratorClients.path,
                    label: getLocalizedString('CATEGORY_NAME__REVIEWS_GENERATOR__CLIENTS'),
                    [nameForAnalytics]: getMenuItemNameForAnalytics('CATEGORY_NAME__REVIEWS_GENERATOR__CLIENTS'),
                },
                {
                    isActivated: reviewsGeneratorLicenses,
                    path: appRoute.reviewsGeneratorQrCode.path,
                    label: getLocalizedString('CATEGORY_NAME__REVIEWS_GENERATOR__QRCODE'),
                    [nameForAnalytics]: getMenuItemNameForAnalytics('CATEGORY_NAME__REVIEWS_GENERATOR__QRCODE'),
                },
                {
                    isActivated: reviewsGeneratorLicenses,
                    path: appRoute.reviewsGeneratorAnalytics.path,
                    label: getLocalizedString('CATEGORY_NAME__REVIEWS_GENERATOR__ANALYTICS'),
                    [nameForAnalytics]: getMenuItemNameForAnalytics('CATEGORY_NAME__REVIEWS_GENERATOR__ANALYTICS'),
                },
                {
                    path: appRoute.reviewsGeneratorPromoCodesList.path,
                    label: getLocalizedString('CATEGORY_NAME__REVIEWS_GENERATOR__PROMO_CODES'),
                    [nameForAnalytics]: getMenuItemNameForAnalytics('CATEGORY_NAME__REVIEWS_GENERATOR__PROMO_CODES'),
                },
                {
                    path: appRoute.reviewsGeneratorQuestionnaireList.path,
                    label: getLocalizedString('CATEGORY_NAME__REVIEWS_GENERATOR__QUESTIONNAIRE'),
                    [nameForAnalytics]: getMenuItemNameForAnalytics('CATEGORY_NAME__REVIEWS_GENERATOR__QUESTIONNAIRE'),
                },
                {
                    path: appRoute.reviewsGeneratorPromoMaterials.path,
                    isOnlyRoute: true,
                    exact: false,
                    label: getLocalizedString('CATEGORY_NAME__REVIEWS_GENERATOR__QRCODE_PROMO_MATERIALS'),
                    [nameForAnalytics]: getMenuItemNameForAnalytics(
                        'CATEGORY_NAME__REVIEWS_GENERATOR__QRCODE_PROMO_MATERIALS'
                    ),
                },
            ],
        },
    ];
}
